export const shouldDecreaseIconOpacityBasedOnStatus = (
  status: number,
  statuses: number[],
) => {
  return statuses.includes(status);
};
